import { memo } from 'react';
import { useForm } from 'react-hook-form';
import { Card, CardContent, Stack, Box, IconButton, Typography, Button, Grid } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { PiHeadCircuitLight } from "react-icons/pi";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useDispatch, useSelector } from 'react-redux';
import { customStep, previousStep } from '../../../../../slice/multiStepSlice';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';


const JobRoleCredentials = () => {
    const { ID } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const { handleSubmit } = useForm();
    const {  values } = useSelector((state) => state?.multiStep)
    const data = [
        { id: 1, icon: <PiHeadCircuitLight color="#C7253E" size={24} />, text: "Specialties", actionIcon: <ChevronRightIcon sx={{ color: '#6ebe44' }} />, route: 2 },
    ];

    const handleRouting = (path) => {
        dispatch(customStep(path))
    }

    const onSubmit = () => {
        navigate(`/admin/profile-criteria`);
    };
    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
            {!values.REDIRECT && <Button
                                    onClick={() => dispatch(previousStep())}
                                    startIcon={<ArrowBackIosIcon sx={{ fontSize: "12px", color: "#000000" }} />}
                                    sx={{ textTransform: 'none', fontWeight: 500, fontSize: "14px", padding: 3, minWidth: 0 }}
                                >
                                </Button>}
                    <Grid lg={12} p={4}>
                        <CardContent>
                            <Typography variant="h2" component="div" mb={4} fontWeight="bold">
                                Set the required credentials for
                                <br />
                                <span style={{ fontWeight: 'bold' }}>this job role</span>
                            </Typography>
                            <Stack spacing={1}>
                                {data.map((item) => (
                                    <Box key={item.id} onClick={() => handleRouting(item.route)} display={"flex"} alignItems={"center"}
                                        sx={{ height: 40, borderRadius: "8px", padding: "5px 10px", cursor: "pointer", backgroundColor: "#f5f5f5" }}>
                                        {item.icon}
                                        <Typography variant="body1" sx={{ marginLeft: '10px', flexGrow: 1 }}>
                                            {item.text}
                                        </Typography>
                                        {item.actionIcon}
                                    </Box>
                                ))}
                            </Stack>
                            <Box display={"flex"} justifyContent={"flex-end"} mt={4}>
                                <Button variant="contained" className='gradientAdminThemeColor' type='submit'>
                                    Finish
                                </Button>
                            </Box>
                        </CardContent>
                        </Grid>
            </form>
        </>
    );
};

export default memo(JobRoleCredentials);
